import {
  USER_ORG_USER_FETCH_ERROR,
  USER_ORG_USER_FETCH_SUCCESS,
  USER_ORG_USER_RESET,
} from 'constants/ActionTypes';

const getInitialState = () => ({
  data: null,
  error: null,
  loaded: false,
  loading: false,
});

export default (state = getInitialState(), action) => {
  switch (action.type) {
    case USER_ORG_USER_FETCH_ERROR: {
      return {
        ...state,
        data: null,
        error: action.payload,
        loaded: true,
        loading: false,
      };
    }
    case USER_ORG_USER_FETCH_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        error: null,
        loaded: true,
        loading: false,
      };
    }

    case USER_ORG_USER_RESET: {
      return getInitialState();
    }

    default:
      return state;
  }
};

